export const characters = [
  {
    slug: "tonek",
    name: "Tonek",
    role: "Bohater z krwi i kości",
    portrait: "/assets/portrait-tonek.png",
    color: "#FDBA74",
    tagline: "Ciekawski i odważny chłopiec",
    bio: "Uwielbia odkrywać nowe miejsca, rozwiązywać zagadki i pomagać innym. Najlepszy przyjaciel Duszka.",
  },
  {
    slug: "duszek",
    name: "Duszek",
    role: "Duszek o wielkim sercu",
    portrait: "/assets/portrait-duszek.png",
    color: "#BAE6FD",
    tagline: "Mały duszek, wielkie serce",
    bio: "Może latać i stawać się niewidzialny. Uwielbia żarty, magię i przygody. Najlepszy przyjaciel Tonka.",
  },
  {
    slug: "napoleon",
    name: "Napoleon",
    role: "Wierny towarzysz",
    portrait: "/assets/portrait-napoleon.png",
    color: "#FCD34D",
    tagline: "Tosa Inu o niezłomnym charakterze",
    bio: "Lojalny, silny i zawsze gotowy do wspólnej przygody. Najlepszy przyjaciel Tonka.",
  },
  {
    slug: "babcia",
    name: "Babcia",
    role: "Strażniczka opowieści",
    portrait: "/assets/portrait-babcia.png",
    color: "#DDD6FE",
    tagline: "Kochająca, mądra, zawsze ma czas",
    bio: "Najlepiej zna tajemnice i historie całego świata. Piecze ciasteczka lepsze niż wszyscy razem wzięci.",
  },
  {
    slug: "wincent",
    name: "Prof. Wincent",
    role: "Wynalazca z chmur",
    portrait: "/assets/portrait-wincent.png",
    color: "#FDE68A",
    tagline: "Genialny wynalazca i przyjaciel",
    bio: "Kocha eksperymenty, maszyny i odkrywanie tajemnic nauki. Zawsze ma pod ręką notes pełen szkiców.",
  },
  {
    slug: "billy",
    name: "Pirat Billy",
    role: "Poszukiwacz skarbów",
    portrait: "/assets/portrait-billy.png",
    color: "#FCA5A5",
    tagline: "Wesoły pirat, który nie boi się (prawie) niczego",
    bio: "Zawsze szuka skarbów i nowych morskich przygód. Kocha morskie opowieści przy ognisku.",
  },
  {
    slug: "robo",
    name: "Robo-3000",
    role: "Przyjaciel z przyszłości",
    portrait: "/assets/portrait-robo.png",
    color: "#A5B4FC",
    tagline: "Robot z przyszłości",
    bio: "Pomocny, lojalny i zawsze gotowy do akcji. Uczy się, że najlepsze algorytmy to te napisane sercem.",
  },
];

export const upcoming = [
  "Zosia",
  "Kot Filemon",
  "Luna",
  "Dino",
  "Rycerz",
  "Podróżnik",
  "Kosmik",
  "Czarodziej",
];
